// This file was once generated when you created this area
// but you can edit it freely

const baseRoute = '/fleets'

export const FleetsAreaRoutes = {
  route: baseRoute,
  path: '/',
}
